const styles = {

    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'start',
        minWidth: '100%',
        minHeight: '100vh',
        bgcolor: 'primary.white',

        logo:{
            width: '7%', height: '7%', marginTop: '0.1rem'
        },

        loginContainer:{
            marginTop: 16,
            marginLeft: 50,
            zIndex: 10,
            boxShadow: 24,
            border: '0px solid #000',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'start',
            minHeight: '60vh',
            width: '70%',
            bgcolor: 'primary.white',
            color: 'white',
            gap: '1rem',
            borderBottomRightRadius: '1rem',

            sideDiv: {
                bgcolor: 'primary.blue',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '35%'
            },

            loginDiv: {
                display: 'flex',
                bgcolor: 'primary.white',
                borderRadius: 1,
                p: 3,
                minWidth: '40%',
                heading: {
                  color: 'text.black'
                },

                textField:{
                    bgcolor: 'text.contrastText',
                    width: '40%',
                    borderRadius: 1
                },

                loginButton: {
                    mt: 3,
                    mb: 2,
                    width: '33%',
                    borderRadius: 5,
                    bgcolor: 'primary.main',
                    color: 'text.contrastText',
                    '&:hover': {
                        bgcolor: 'pruColor.tints.blueTint75'
                    },
                    textTransform: 'none',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '1rem'
                },

                accountRecovery: {
                    marginTop: '1.5rem',
                    marginLeft: '0.5rem',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'start',
                    alignItems: 'start',
                    gap: '1rem',
                    link: {
                        fontSize: '0.7rem',
                        fontWeight: '800',
                        letterSpacing: '.01em',
                        color: 'primary.main'
                    }
                }
            }

        }


    }

};

export default styles;
